<template>
  <div id="app">
    <NavBar></NavBar>
    <main class="main-content">
      <router-view/>
    </main>
    <Footer></Footer>
    <FloatingWidget />
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
import Footer from '@/components/Footer.vue'
import FloatingWidget from '@/components/FloatingWidget.vue'

export default {
  components: {
    NavBar,
    Footer,
    FloatingWidget
  }
}
</script>

<style lang="scss">
#app {
  font-family: var(--font-family);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--color-text);
  min-height: 100%;
  background-color: var(--color-bg);
}

.main-content {
  min-height: calc(100vh - var(--nav-height) - 200px);
}

.page-section {
  padding: var(--section-padding);
  max-width: var(--max-width);
  margin: 0 auto;
}

.page-section--alt {
  background: var(--color-bg-alt);
}

.btn-more {
  display: inline-block;
  margin-top: 2.5rem;
  padding: 0.625rem 2.5rem;
  border: 2px solid var(--color-primary);
  color: var(--color-primary);
  border-radius: var(--radius-sm);
  font-size: 1rem;
  transition: all 0.25s;
  background: transparent;
  cursor: pointer;
  text-decoration: none;

  &:hover {
    background: var(--color-primary);
    color: #fff;
    text-decoration: none;
  }
}
</style>
